import * as linkConst from '../constants/link_constants'

export function convertQuery (q = {}) {
  let converted = {}
  if (q._page && q._perPage) {
    converted.offset = (q._page - 1) * q._perPage
    converted.limit = q._perPage
  }
  if (q._sortField) {
    const fieldList = q._sortField.split(',')
    const ordField = q._sortDir.split(',')
    converted.sort = JSON.stringify(fieldList.map((i, idx) => {
      return [i, ordField[idx]]
    }))
  }
  if (q.embed) {
    converted.embed = JSON.stringify(q.embed.split(','))
    delete q.embed
  }
  const filter = {}
  for (let i in q) {
    if (i[0] !== '_') {
      filter[i] = q[i]
    }
  }
  if (Object.keys(filter).length > 0) {
    converted.filter = filter
  }
  if (q._extraparams && Object.keys(q._extraparams).length > 0) {
    converted = Object.assign(converted, q._extraparams)
  }
  // add global data filter
  if (q[linkConst.FILTER_DATE.paramVal] && q[linkConst.FILTER_DATE.paramKey]) {
    converted.filter = converted.filter || {}
    converted.filter[linkConst.FILTER_DATE.apiKey] = [
      q[linkConst.FILTER_DATE.paramVal],
      q[linkConst.FILTER_DATE.paramKey]
    ].join(',')
  }
  // add global region filter
  if (q[linkConst.FILTER_REGION.paramVal] && q[linkConst.FILTER_REGION.paramKey]) {
    converted.filter = converted.filter || {}
    converted.filter[linkConst.FILTER_REGION.apiKey] = [
      q[linkConst.FILTER_REGION.paramVal],
      q[linkConst.FILTER_REGION.paramKey]
    ].join(',')
  }
  // add global history filter
  if (q[linkConst.HISTORY_FILTER.paramVal] && q[linkConst.HISTORY_FILTER.paramKey]) {
    converted.filter = converted.filter || {}
    converted.filter[linkConst.HISTORY_FILTER.apiKey] = [
      q[linkConst.HISTORY_FILTER.paramVal],
      q[linkConst.HISTORY_FILTER.paramKey]
    ].join(',')
  }
  return converted
}

export function getTotalItems (response) {
  const h = response.headers['x-total-count']
  return h ? parseInt(h) : response.data.length
}
